import { render, staticRenderFns } from "./ListIncoterms.vue?vue&type=template&id=024c99e0"
import script from "./ListIncoterms.vue?vue&type=script&lang=js"
export * from "./ListIncoterms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports